exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".recommend-items-base[data-v-6d905bad],.recommend-items-base h4[data-v-6d905bad]{width:100%}.recommend-items-base h4 img[data-v-6d905bad]{display:block;margin:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6d905bad","scoped":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/utvStore/components/YearLuck/y2020/partials/recommendItems.vue
// module id = x3ke
// module chunks = 0